import { useEffect, useState } from 'react'
import { useReducedMotion } from 'framer-motion'

/**
 * Cycles through 0..steps-1 on an interval to drive looping explainer animations.
 * With reduced motion, it holds the final (fully explained) state.
 */
export function useStepCycle(steps: number, intervalMs: number) {
  const reduceMotion = useReducedMotion()
  const [step, setStep] = useState(0)

  useEffect(() => {
    if (reduceMotion) return
    const id = setInterval(() => setStep((s) => (s + 1) % steps), intervalMs)
    return () => clearInterval(id)
  }, [steps, intervalMs, reduceMotion])

  return reduceMotion ? steps - 1 : step
}
